export function hideZendeskWidgetForPrint() {
  const zendeskWidget = document.getElementById("launcher");

  zendeskWidget?.classList.add("hidden-print");
}
